import { JSX } from 'react'

import { Tooltip } from '~/components/component-library'

/**
 * Shared disabled treatment for inputs: keep the normal background and dim the
 * whole control instead of filling it gray, which reads as a subtler "off"
 * state. Applied wherever an input renders its disabled chrome.
 */
export const DISABLED_INPUT_CLASSNAME = 'cursor-not-allowed opacity-50'

/**
 * Wraps a disabled input's trigger in a tooltip explaining why it's
 * unavailable. Renders `children` untouched unless both `disabled` and
 * `disabledReason` are set, so enabled inputs pay no wrapper cost.
 *
 * The disabled control itself should be `pointer-events-none` so hover falls
 * through to this wrapper — a disabled element otherwise swallows the events
 * the tooltip needs.
 */
export const DisabledReasonTooltip = ({
  disabled,
  disabledReason,
  className,
  children,
}: {
  disabled?: boolean
  disabledReason?: string
  className?: string
  children: JSX.Element
}): JSX.Element =>
  disabled && disabledReason ? (
    <Tooltip content={disabledReason} className={className}>
      {children}
    </Tooltip>
  ) : (
    children
  )

DisabledReasonTooltip.displayName = 'DisabledReasonTooltip'
